export const JOB_STATES =  {
    'newJob': 'newJob',
    'draftJob': 'drafts',
    'activeJob': 'active',
    'expiredJob': 'expired'
};
